import { AnswerType, DependencyType, QuestionDependencyView, QuestionView } from '@data/sdk/match';

export const getQuestionsByDependencyType = (dependencyType: DependencyType) => {
  switch (dependencyType) {
    case DependencyType.GreaterThan:
    case DependencyType.BmiCalculation:
      return AnswerType.Number;

    case DependencyType.DateToMonths:
    case DependencyType.DateToYears:
      return AnswerType.Date;

    case DependencyType.Address:
      return AnswerType.String;

    case DependencyType.Dependency:
      return AnswerType.Boolean;

    default:
      return undefined;
  }
};

export const getHiddenFormInitialValues = (dependency: QuestionDependencyView) => ({
  type: dependency.type,
  // A BMI dependency stores [lengthId, weightId], so the source can sit at either index.
  parameter:
    dependency.type === DependencyType.BmiCalculation
      ? dependency.parameters.find((id) => id !== dependency.sourceId)
      : dependency.parameters[0],
  source: { label: dependency?.text, value: dependency?.sourceId },
});

export const getHiddenFormInitialValuesFromQuestion = (question: QuestionView) => ({
  source: { label: question?.text, value: question?.id },
});
